/**
 * What the home page says about a lesson that closed itself (SRS I2).
 *
 * Kept away from React so the wording can be unit-tested. The date arrives already
 * written out by the server, because the teacher's clock lives on their record and
 * a lesson is dated by the teacher's day, not the browser's (SRS I3).
 */

import type { RecoveredLesson } from './api.js';

/** The exact sentence docs/06-UI-SPEC.md §5 requires. */
export function recoveryMessage(lesson: RecoveredLesson): string {
  return `Your lesson from ${lesson.date} wasn't closed properly — it's been saved.`;
}

/**
 * The one lesson the notice is about, or nothing when there is no notice to show.
 *
 * The newest, because that is the lesson the teacher just walked away from and the
 * one they will look for first.
 */
export function noticeToShow(
  lessons: readonly RecoveredLesson[],
): RecoveredLesson | null {
  return lessons[0] ?? null;
}
